import React, { useCallback } from "react";

const Spinner = () => (
  <div className="spinner btn-spinner" aria-hidden="true">
    <div className="spinner-icon" />
  </div>
);

const Button = ({
  label = "",
  onClick,
  color = "primary",
  disabled = false,
  fullWidth = false,
  className = "",
  type = "button",
  showSpinner = false,
  children,
  ...rest
}) => {
  const isDisabled = disabled || showSpinner;

  const classes = [
    "carlsberg-ticketing-btn",
    `color-${color}`,
    fullWidth ? "full-width" : "",
    isDisabled ? "disabled" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const handleClick = useCallback(
    (event) => {
      event.stopPropagation();
      if (isDisabled) return;
      if (typeof onClick === "function") onClick(event);
    },
    [isDisabled, onClick]
  );

  return (
    <button
      className={classes}
      type={type}
      disabled={isDisabled}
      aria-disabled={isDisabled}
      aria-busy={showSpinner}
      onClick={handleClick}
      {...rest}
    >
      {showSpinner ? <Spinner /> : (children ?? label)}
    </button>
  );
};

export default React.memo(Button);
